import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { TosSuperscriptListPrice } from '../../../tos-superscripts'
import { gkAirGetFormattedPrice } from '../../gkAirGetFormattedPrice'
import { gkAirAccessorGetLocalizedProductBasePriceUnit } from '../../model/gkAirAccessorGetLocalizedProductBasePriceUnit'

export const GkAirProductPrice: FC<{
  product?: GkAirRecommendedProductDataWeb
}> = ({ product }) => {
  const { locale } = useGlobalConfigContext()
  const intl = useIntl()

  if (!product) {
    return (
      <div className="min-h-[calc(var(--type-scale-l-line-height)+var(--type-scale-s-line-height)+var(--type-scale-s-line-height))]">
        <Skeleton className="mx-auto w-4/5" />
      </div>
    )
  }
  const { base_price_amount, price, reduced, strike_through_price } = product
  // Type-safe dynamic key access for unit
  const unit = gkAirAccessorGetLocalizedProductBasePriceUnit({
    locale,
    product,
  })

  return (
    <div className="flex flex-col">
      <span className="flex flex-col">
        {reduced === 'true' && strike_through_price !== null && (
          <span className="min-h-[var(--type-scale-s-line-height)] whitespace-nowrap text-dark-primary-strong line-through">
            {gkAirGetFormattedPrice({
              intl,
              price: strike_through_price,
            })}
            <TosSuperscriptListPrice price={strike_through_price} />
          </span>
        )}
        <span className="whitespace-nowrap text-2xl font-bold leading-l text-dark-brand">
          {gkAirGetFormattedPrice({
            intl,
            price,
          })}
        </span>
      </span>
      <span className="min-h-[var(--type-scale-s-line-height)] text-s text-dark-primary-strong">
        {gkAirGetFormattedPrice({
          intl,
          price: base_price_amount,
          unit,
        })}
        <TosSuperscriptListPrice price={base_price_amount} />
      </span>
    </div>
  )
}
